import React from "react";
import { PlusIcon } from "../../../assets/icons";
import style from "./ButtonCircle.module.css";

const ButtonCircle = ({
  backgroundCircle = "var(--primary-color-dark)",
  Icon = PlusIcon,
  widthCircle = "2.7vw",
  widthIcon = "0.8vw",
  colorIcon = "white",
}) => {
  return (
    <div
      style={{
        "--width-circle": widthCircle,
        "--width-icon": widthIcon,
        "--background-circle": backgroundCircle,
        "--fill-icon": colorIcon,
      }}
      className={`${style.content}`}
    >
      <Icon className={`${style.icon}`} />
    </div>
  );
};

export default ButtonCircle;
